var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "input-mobile",
      class: {
        "align-center": _vm.$attrs.align === "center",
        sent: _vm.isSent,
      },
    },
    [
      _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "tel" },
            domProps: { value: _vm.inputValue },
            on: {
              change: _vm.changeHandle,
              keyup: _vm.changeHandle,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inputValue = $event.target.value
              },
            },
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _vm.verify && !_vm.verified
        ? _c("div", { staticClass: "verify-input" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: {
                  disabled: !_vm.isValidMobile || _vm.sent || _vm.verifying,
                  type: "button",
                },
                on: { click: _vm.sendCode },
              },
              [
                _vm.sent
                  ? _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.t("register.code_sent")) +
                          " (" +
                          _vm._s(_vm.countdown) +
                          "s)\n      "
                      ),
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.isSent
                              ? _vm.t("register.resend_code")
                              : _vm.t("register.get_code")
                          ) +
                          "\n      "
                      ),
                    ]),
              ]
            ),
            _vm._v(" "),
            _c("input", {
              ref: "code",
              attrs: {
                placeholder: _vm.t("register.code"),
                type: "tel",
                maxlength: "4",
                minlength: "4",
                name: "smsVerifyCode",
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.verified ? _c("i", { staticClass: "fa fa-check" }) : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }